/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { MouseEventHandler } from 'react';
import useAppLanguage from 'hooks/use-app-language';
import appUrls from 'helpers/app-urls';
import ButtonSpinner from 'components/ButtonSpinner';
import { SSOAuthProvider } from 'entities/sso';
import device from 'helpers/device';

export const SSOButton = ({
  flow,
  provider,
  onLogin,
  isLoading,
  isDisabled,
}: {
  flow: 'login' | 'signup';
  provider: SSOAuthProvider;
  onLogin: MouseEventHandler<HTMLDivElement | HTMLButtonElement>;
  isLoading: boolean;
  isDisabled: boolean;
}) => {
  // #region HOOKS
  const language = useAppLanguage();
  const { isDeviceMobile } = device();
  // #endregion

  const imageSize = 24;
  const imageUrl = `${appUrls.getCDNUrl()}${
    isDeviceMobile ? provider.imagePathMobile : (provider.imagePath as string)
  }`;

  return (
    <button
      type="button"
      onClick={e => onLogin(e)}
      className={`w-full focus:outline-none ${
        isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
      }`}
      disabled={isDisabled}
    >
      <div
        className="mx-0 h-12 rounded-l-full rounded-r-full mb-0 mt-4"
        style={{
          color: isDeviceMobile
            ? provider.colors.mobileText
            : provider.colors.text,
          backgroundColor: isDeviceMobile
            ? provider.colors.mobileBackground
            : provider.colors.background,
          border: `1px solid ${
            isDeviceMobile ? provider.colors.mobileText : 'transparent'
          }`,
        }}
      >
        <div className="flex flex-row w-full text-center justify-center items-center">
          {isLoading ? (
            <div className="h-10 py-3">
              <ButtonSpinner />
            </div>
          ) : (
            <>
              <img
                alt="sso-logo"
                src={imageUrl}
                width={imageSize}
                height={imageSize}
                className="mt-3 -ml-4 w-6 h-6"
              />
              <div
                className="pt-3 ml-4 font-semibold"
                style={{
                  color: 'inherit',
                }}
              >
                {provider.text[language][flow]}
              </div>
            </>
          )}
        </div>
      </div>
    </button>
  );
};

export default SSOButton;
